"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var query_exports = {};
__export(query_exports, {
  NotificationContextsQuery: () => NotificationContextsQuery
});
module.exports = __toCommonJS(query_exports);
var import_communication_types = require("@hcengineering/communication-types");
var import_communication_sdk_types = require("@hcengineering/communication-sdk-types");
var import_communication_shared = require("@hcengineering/communication-shared");
var import_types = require("../types");
var import_result = require("../result");
var import_window = require("../window");
var import_utils = require("../utils");
class NotificationContextsQuery {
  constructor(client, teronlake, id, params, options, callback, initialResult) {
    this.client = client;
    this.teronlake = teronlake;
    this.id = id;
    this.params = params;
    this.options = options;
    this.callback = callback;
    this.params = {
      ...params,
      limit: params.limit,
      order: params.order ?? import_types.defaultQueryParams.order
    };
    if (initialResult !== void 0) {
      this.result = initialResult;
      void this.notify();
    } else {
      this.result = this.initResult();
      void this.result.then(() => {
        void this.notify();
      });
    }
  }
  static {
    __name(this, "NotificationContextsQuery");
  }
  result;
  forward = { isDone: false };
  backward = { isDone: false };
  nexLoadedPagesCount = 0;
  prevLoadedPagesCount = 0;
  messagesBuffer = [];
  async rawInitResult() {
    const limit = this.params.limit != null ? this.params.limit + 1 : void 0;
    const findParams = {
      ...this.params,
      order: this.params.order ?? import_types.defaultQueryParams.order,
      limit
    };
    const res = await this.find(findParams);
    const isComplete = limit == null || res.length < limit;
    if (!isComplete) res.pop();
    const isTail = isComplete || this.params.lastNotify == null && this.params.order === import_communication_types.SortingOrder.Descending;
    const isHead = isComplete || this.params.lastNotify == null && this.params.order === import_communication_types.SortingOrder.Ascending;
    const result = new import_result.QueryResult(res, (it) => it.id);
    result.setTail(isTail);
    result.setHead(isHead);
    return result;
  }
  async initResult() {
    try {
      return await this.rawInitResult();
    } catch (error) {
      console.error("Failed to initialize query:", error);
      return new import_result.QueryResult([], (it) => it.id);
    }
  }
  async onEvent(event) {
    switch (event.type) {
      case import_communication_sdk_types.MessageEventType.CreateMessage:
        await this.onCreateMessageEvent(event);
        break;
      case import_communication_sdk_types.MessageEventType.BlobPatch:
      case import_communication_sdk_types.MessageEventType.AttachmentPatch:
      case import_communication_sdk_types.MessageEventType.RemovePatch:
      case import_communication_sdk_types.MessageEventType.UpdatePatch: {
        await this.onCreatePatchEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.CreateNotificationContext: {
        await this.onCreateNotificationContextEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.UpdateNotificationContext: {
        await this.onUpdateNotificationContextEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.RemoveNotificationContext: {
        await this.onRemoveNotificationContextEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.CreateNotification: {
        await this.onCreateNotificationEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.RemoveNotifications: {
        await this.onRemoveNotificationEvent(event);
        break;
      }
      case import_communication_sdk_types.NotificationEventType.UpdateNotification: {
        await this.onUpdateNotificationEvent(event);
        break;
      }
      case import_communication_sdk_types.CardEventType.RemoveCard:
        await this.onCardRemoved(event);
        break;
    }
  }
  async onRequest(event) {
  }
  async unsubscribe() {
  }
  async requestLoadNextPage(notify = true) {
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.result.isTail()) return { isDone: true };
    const last = this.result.getLast();
    if (last === void 0) return { isDone: false };
    const limit = this.params.limit ?? import_types.defaultQueryParams.limit;
    const findParams = {
      ...this.params,
      lastNotify: {
        greater: last.lastNotify
      },
      limit: limit + 1,
      order: import_communication_types.SortingOrder.Ascending
    };
    const forward = this.find(findParams);
    const forwardPromise = forward.then(async (res) => {
      if (this.result instanceof Promise) {
        this.result = await this.result;
      }
      const isTail = res.length <= limit;
      if (!isTail) {
        res.pop();
      }
      this.result.append(res);
      this.result.setTail(isTail);
      this.nexLoadedPagesCount++;
      if (notify) {
        await this.notify();
      }
      return { isDone: isTail };
    });
    this.forward = forwardPromise;
    return await forwardPromise;
  }
  async requestLoadPrevPage(notify = true) {
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result.isHead()) return { isDone: true };
    const first = this.params.order === import_communication_types.SortingOrder.Ascending ? this.result.getFirst() : this.result.getLast();
    if (first === void 0) return { isDone: false };
    const limit = this.params.limit ?? import_types.defaultQueryParams.limit;
    const findParams = {
      ...this.params,
      lastNotify: {
        less: first.lastNotify
      },
      limit: limit + 1,
      order: import_communication_types.SortingOrder.Descending
    };
    const backward = this.find(findParams);
    const backwardPromise = backward.then(async (res) => {
      if (this.result instanceof Promise) this.result = await this.result;
      const isHead = res.length <= limit;
      if (!isHead) {
        res.pop();
      }
      if (this.params.order === import_communication_types.SortingOrder.Ascending) {
        const reversed = res.reverse();
        this.result.prepend(reversed);
      } else {
        this.result.append(res);
      }
      this.result.setHead(isHead);
      this.prevLoadedPagesCount++;
      if (notify) {
        await this.notify();
      }
      return { isDone: isHead };
    });
    this.backward = backwardPromise;
    return await backwardPromise;
  }
  removeCallback() {
    this.callback = () => {
    };
  }
  setCallback(callback) {
    this.callback = callback;
    void this.notify();
  }
  copyResult() {
    if (this.result instanceof Promise) {
      return void 0;
    }
    return this.result.copy();
  }
  async findMessage(cardId, blobId, messageId) {
    const fromBuffer = this.messagesBuffer.find((it) => it.cardId === cardId && it.id === messageId);
    if (fromBuffer != null) {
      return fromBuffer;
    }
    return (await (0, import_utils.loadMessages)(this.teronlake, cardId, blobId, { cardId, id: messageId }, { attachments: true }))[0];
  }
  async loadMessages(contexts) {
    const cache = /* @__PURE__ */ new Map();
    const newContexts = await Promise.all(
      contexts.map(async (context) => {
        const notifications = context.notifications ?? [];
        context.notifications = await Promise.all(
          notifications.map(async (notification) => {
            const message = (await (0, import_utils.loadMessages)(
              this.teronlake,
              context.cardId,
              notification.blobId,
              { cardId: context.cardId, id: notification.messageId },
              { attachments: true },
              cache
            ))[0];
            if (message !== void 0) {
              return {
                ...notification,
                message
              };
            }
            return notification;
          })
        );
        return context;
      })
    );
    cache.clear();
    return newContexts;
  }
  async find(params) {
    const contexts = await this.client.findNotificationContexts(params, this.id);
    if (this.options?.message !== true || this.params.notifications == null) return contexts;
    return await this.loadMessages(contexts);
  }
  async onCreateNotificationContextEvent(event) {
    if (event.contextId === void 0) return;
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    if (this.result.get(event.contextId) !== void 0) {
      return;
    }
    const context = import_communication_shared.NotificationContextProcessor.create(event);
    if (!this.match(context)) {
      return;
    }
    this.addContext(context, this.result);
    void this.notify();
  }
  async onCreateMessageEvent(event) {
    if (this.params.notifications == null || this.options?.message !== true) return;
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    const context = this.result.getResult().find((it) => it.cardId === event.cardId);
    if (context === void 0) return;
    this.messagesBuffer.push(import_communication_shared.MessageProcessor.create(event));
    const delay = 10 * 60 * 1e3;
    this.messagesBuffer = this.messagesBuffer.filter((it) => it.created.getTime() - Date.now() < delay);
  }
  async onCreatePatchEvent(event) {
    const isUpdated = await this.updateMessage(
      event.cardId,
      event.messageId,
      (message) => import_communication_shared.MessageProcessor.applyPatch(message, event)
    );
    if (isUpdated) {
      void this.notify();
    }
    this.messagesBuffer = this.messagesBuffer.map((it) => {
      if (it.cardId === event.cardId && it.id === event.messageId) {
        return import_communication_shared.MessageProcessor.applyPatch(it, event);
      }
      return it;
    }).filter((it) => it != null);
  }
  async onRemoveNotificationEvent(event) {
    if (this.params.notifications == null) return;
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    const context = this.result.get(event.contextId);
    if (context === void 0) return;
    if (this.params.notifications.total === true) {
      const c = (await this.find({ id: context.id, limit: 1, notifications: this.params.notifications }))[0];
      if (c != null) {
        this.result.update(c);
        void this.notify();
      } else {
        this.result.delete(context.id);
        void this.notify();
      }
      return;
    }
    if (context?.notifications === void 0) return;
    const filtered = context.notifications.filter((it) => !event.ids.includes(it.id));
    if (filtered.length === context.notifications.length) return;
    const limit = this.params.notifications.limit ?? 0;
    if (filtered.length < limit && context.notifications.length >= limit) {
      const contextUpdated = (await this.find({ id: context.id, limit: 1, notifications: this.params.notifications }))[0];
      if (contextUpdated !== void 0) {
        this.result.update(contextUpdated);
      } else {
        this.result.delete(context.id);
      }
    } else {
      this.result.update({
        ...context,
        notifications: filtered
      });
    }
    void this.notify();
  }
  async onUpdateNotificationEvent(event) {
    if (this.params.notifications == null) return;
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    const context = this.result.get(event.contextId);
    if (context === void 0) return;
    const totalNotifications = this.getNotificationsTotal(context, event);
    const shouldRefreshTotal = this.params.notifications.total === true && this.params.notifications.type != null;
    let matchQuery = { ...event.query, contextId: event.contextId, account: event.account };
    if (event.query.untilDate != null) {
      matchQuery = { ...matchQuery, created: { lessOrEqual: event.query.untilDate } };
    }
    const toUpdate = (context.notifications ?? []).filter(
      (it) => (0, import_utils.matchNotification)(it, matchQuery) && it.read !== event.updates.read
    );
    if (toUpdate === void 0 || (toUpdate?.length ?? 0) === 0) {
      if (shouldRefreshTotal) {
        const nRes = await this.client.findNotifications({
          ...this.params.notifications,
          contextId: context.id,
          limit: 1,
          total: true
        });
        this.result.update({
          ...context,
          totalNotifications: nRes.total
        });
        void this.notify();
      } else if (totalNotifications !== context.totalNotifications) {
        this.result.update({
          ...context,
          totalNotifications
        });
        void this.notify();
      }
      return;
    }
    const toUpdateMap = new Map(toUpdate.map((it) => [it.id, it]));
    const currentLength = context.notifications?.length ?? 0;
    const newNotifications = (context.notifications ?? []).map(
      (it) => toUpdateMap.has(it.id) ? { ...it, ...event.updates } : it
    );
    const newLength = newNotifications.length;
    const shouldRefreshLimit = newLength < currentLength && newLength < this.params.notifications.limit;
    if (shouldRefreshLimit) {
      const updated = (await this.find({ id: context.id, limit: 1, notifications: this.params.notifications }))[0];
      if (updated !== void 0) {
        this.result.update(updated);
      } else {
        this.result.delete(context.id);
      }
    } else if (shouldRefreshTotal) {
      const nRes = await this.client.findNotifications({
        ...this.params.notifications,
        contextId: context.id,
        limit: 1,
        total: true
      });
      this.result.update({
        ...context,
        notifications: newNotifications,
        totalNotifications: nRes.total
      });
    } else {
      this.result.update({
        ...context,
        notifications: newNotifications,
        totalNotifications
      });
    }
    void this.notify();
  }
  getNotificationsTotal(context, event) {
    const updatedCount = event.updated ?? 0;
    if (this.params.notifications?.total === true && updatedCount > 0) {
      if (this.params.notifications?.read != null && this.params.notifications.read === event.updates.read) {
        return (context.totalNotifications ?? 0) + updatedCount;
      } else if (this.params.notifications?.read != null && this.params.notifications.read !== event.updates.read) {
        return Math.max(0, (context.totalNotifications ?? 0) - updatedCount);
      }
    }
    return context.totalNotifications ?? 0;
  }
  async onCreateNotificationEvent(event) {
    if (this.params.notifications == null || event.notificationId == null) return;
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    const notification = import_communication_shared.NotificationProcessor.create(event);
    const match = (0, import_utils.matchNotification)(notification, {
      type: this.params.notifications.type,
      read: this.params.notifications.read
    });
    if (!match) return;
    const context = this.result.get(notification.contextId);
    if ((context?.notifications ?? []).some((it) => it.id === notification.id)) return;
    if (context !== void 0) {
      const message = this.options?.message === true ? await this.findMessage(context.cardId, notification.blobId, notification.messageId) : void 0;
      const notifications = [
        {
          ...notification,
          message
        },
        ...context.notifications ?? []
      ];
      if (notifications.length > this.params.notifications.limit) {
        notifications.pop();
      }
      this.result.update({
        ...context,
        ...this.params.notifications.total === true ? { totalNotifications: (context.totalNotifications ?? 0) + 1 } : {},
        notifications
      });
      void this.notify();
    } else {
      const newContext = (await this.find({ id: notification.contextId, notifications: this.params.notifications, limit: 1 }))[0];
      if (newContext !== void 0) {
        this.addContext(newContext, this.result);
        void this.notify();
      }
    }
  }
  async onRemoveNotificationContextEvent(event) {
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    const length = this.result.length;
    const deleted = this.result.delete(event.contextId);
    if (deleted != null) {
      if (this.params.limit != null && length >= this.params.limit && this.result.length < this.params.limit) {
        await this.reinit(length);
      } else {
        void this.notify();
      }
    }
  }
  async reinit(limit) {
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    this.result = this.find({ ...this.params, limit: limit + 1 }).then((res) => {
      const isTail = res.length <= limit || this.params.order === import_communication_types.SortingOrder.Descending && this.params.lastNotify == null;
      const isHead = res.length <= limit || this.params.order === import_communication_types.SortingOrder.Ascending && this.params.lastNotify == null;
      if (res.length > limit) {
        res.pop();
      }
      const result = new import_result.QueryResult(res, (it) => it.id);
      result.setHead(isHead);
      result.setTail(isTail);
      return result;
    });
    void this.result.then((res) => {
      void this.notify();
      return res;
    });
  }
  async onUpdateNotificationContextEvent(event) {
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    const contextToUpdate = this.result.get(event.contextId);
    if (contextToUpdate === void 0) return;
    const updated = {
      ...contextToUpdate,
      lastUpdate: event.updates.lastUpdate ?? contextToUpdate.lastUpdate,
      lastView: event.updates.lastView ?? contextToUpdate.lastView,
      lastNotify: event.updates.lastNotify ?? contextToUpdate.lastNotify
    };
    this.result.update(updated);
    if (event.updates.lastNotify != null) {
      this.sort(this.result);
    }
    void this.notify();
  }
  async onCardRemoved(event) {
    if (this.result instanceof Promise) this.result = await this.result;
    let updated = false;
    const result = this.result.getResult();
    for (const context of result) {
      if (context.cardId === event.cardId) {
        this.result.delete(context.id);
        updated = true;
      }
    }
    if (updated) {
      if (this.params.limit != null && this.result.length < this.params.limit && result.length >= this.params.limit) {
        const contexts = await this.find(this.params);
        this.result = new import_result.QueryResult(contexts, (x) => x.id);
      }
      void this.notify();
    }
  }
  addContext(context, result) {
    if (result.get(context.id) !== void 0) return;
    if (result.isTail()) {
      if (this.params.order === import_communication_types.SortingOrder.Ascending) {
        result.push(context);
      } else {
        result.unshift(context);
      }
    }
    if (this.params.limit != null && result.length > this.params.limit) {
      result.pop();
    }
    this.sort(result);
  }
  sort(result) {
    result.sort(
      (a, b) => this.params.order === import_communication_types.SortingOrder.Descending ? (b.lastNotify?.getTime() ?? 0) - (a.lastNotify?.getTime() ?? 0) : (a.lastNotify?.getTime() ?? 0) - (b.lastNotify?.getTime() ?? 0)
    );
  }
  match(context) {
    if (this.params.cardId !== void 0) {
      const cards = Array.isArray(this.params.cardId) ? this.params.cardId : [this.params.cardId];
      if (!cards.includes(context.cardId)) return false;
    }
    if (this.params.id !== void 0 && context.id !== this.params.id) {
      return false;
    }
    if (this.params.lastNotify !== void 0) {
      if ("greater" in this.params.lastNotify && this.params.lastNotify.greater != null && (context.lastNotify?.getTime() ?? 0) <= this.params.lastNotify.greater.getTime()) {
        return false;
      }
      if ("less" in this.params.lastNotify && this.params.lastNotify.less != null && (context.lastNotify?.getTime() ?? 0) >= this.params.lastNotify.less.getTime()) {
        return false;
      }
      if ("greaterOrEqual" in this.params.lastNotify && this.params.lastNotify.greaterOrEqual != null && (context.lastNotify?.getTime() ?? 0) < this.params.lastNotify.greaterOrEqual.getTime()) {
        return false;
      }
      if ("lessOrEqual" in this.params.lastNotify && this.params.lastNotify.lessOrEqual != null && (context.lastNotify?.getTime() ?? 0) > this.params.lastNotify.lessOrEqual.getTime()) {
        return false;
      }
      if (this.params.lastNotify instanceof Date && this.params.lastNotify !== context.lastNotify) {
        return false;
      }
    }
    return true;
  }
  async notify() {
    if (this.callback === void 0) return;
    if (this.result instanceof Promise) {
      this.result = await this.result;
    }
    const result = this.result.getResult();
    const isTail = this.result.isTail();
    const isHead = this.result.isHead();
    const window = new import_window.WindowImpl(result, this.result.getTotal(), isTail, isHead, this);
    this.callback(window);
  }
  async updateMessage(card, messageId, updater) {
    if (this.params.notifications == null || this.options?.message !== true) return false;
    if (this.forward instanceof Promise) this.forward = await this.forward;
    if (this.backward instanceof Promise) this.backward = await this.backward;
    if (this.result instanceof Promise) this.result = await this.result;
    const context = this.result.getResult().find((it) => it.cardId === card);
    if (context === void 0 || (context.notifications ?? []).length === 0) return false;
    const hasMessage = context.notifications?.some((it) => it.messageId === messageId) ?? false;
    if (!hasMessage) return false;
    this.result.update({
      ...context,
      notifications: context.notifications?.map((it) => ({
        ...it,
        message: it.messageId === messageId && it.message != null ? updater(it.message) : it.message
      }))
    });
    return true;
  }
  async refresh() {
    const nextPagesCount = this.nexLoadedPagesCount;
    const prevPagesCount = this.prevLoadedPagesCount;
    this.result = new import_result.QueryResult([], (it) => it.id);
    this.nexLoadedPagesCount = 0;
    this.prevLoadedPagesCount = 0;
    this.result = await this.rawInitResult();
    for (let i = 0; i < nextPagesCount; i++) {
      const { isDone } = await this.requestLoadNextPage(false);
      if (!isDone) break;
    }
    for (let i = 0; i < prevPagesCount; i++) {
      const { isDone } = await this.requestLoadPrevPage(false);
      if (!isDone) break;
    }
    await this.notify();
  }
}
//# sourceMappingURL=query.js.map
